<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>
<script>
import { ref } from "vue";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    const locale = ref(zhCn);
    return {
      locale,
    };
  },
};
</script>

<style lang='scss'>
.el-input__wrapper{
  // padding:0 !important;
}
.el-select .el-input .el-select__caret.el-icon{
  svg{
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    top:0;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #eeeeee;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

body {
  margin: 0;
}
.el-button--default {
  background-color: white!important;
  border:2px solid #13BD7F!important;
  color: #13BD7F !important
}
.el-button:active {
    background-color: #C8CBC9 !important;
    border-color: #C8CBC9 !important;
    outline: 0;
}
.el-dropdown-menu {
  background: #323642 !important;
}
.el-dropdown-menu:hover {
  background: #323642 !important;
}
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background: rgba(255, 255, 255, 0.18) !important;
  color: #323642;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #dfdfdf !important;
}
.el-dropdown__popper.el-popper[role="tooltip"] {
  background: #323642 !important;
  border: none !important;
}
.el-dropdown-menu__item {
  color: #b6b6b6 !important;
}
.el-popper__arrow {
  display: none;
}
.el-button--success {
  background: #13bd7f !important;
  border-color: #13bd7f !important;
  color:white !important
}
.el-button--success.is-active,
.el-button--success:active {
  background: #0d8559 !important;
  border-color: #0d8559 !important;
}
.el-button{
  // padding: 0 !important;
}
.el-button--warning {
  background: #E3E3E3 !important;
  border-color: #e3e3e3 !important;
  color: black !important;
}
.open .el-icon-close {
  position: absolute !important;
  top: 17px !important;
  right: 17px !important;
  cursor: pointer !important;
  font-size: 25px;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
}
.el-pagination{
  text-align: left;
  margin: 12px 0;
}
.el-loading-parent--relative {
	position: relative!important;
    pointer-events: auto!important;
}
.width-80{
  width: 80px;
}
</style>
